import { IS_TEST_ENV } from '@trustoo/constants/buildEnvironment'

export const IS_BROWSER = typeof window !== 'undefined'

const host = IS_BROWSER ? window.location.host : ''

export const IS_LOCAL = host.startsWith('l.') || host.startsWith('localhost')

export const IS_TEST_SUBDOMAIN = host.startsWith('test')

export const IS_EPHEMERAL = host.includes('.ephemeral.')

/**
 * Non-production signal. The host checks only work in the browser; the build-time
 * {@link IS_TEST_ENV} keeps it valid while server rendering in the Next.js apps, so both sides of a
 * hydration agree there.
 */
export const IS_TEST = IS_LOCAL || IS_TEST_SUBDOMAIN || IS_EPHEMERAL || IS_TEST_ENV
